/**
 * SIGFU REST API
 * Serveur d\'api en NodeJs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepotLigne } from './depotLigne';
import { DepotLigneAddress } from './depotLigneAddress';


export interface DepotLigneParty { 
    idParty: number;
    depotLigne: DepotLigne;
    address: DepotLigneAddress;
    action: string;
    beginLife: string;
    birthDate: string;
    birthPlace: string;
    citizenship: string;
    companyCapital: number;
    companyType: string;
    countryOfOrigin: string;
    createDate: string;
    currentId: string;
    deathDate: string;
    deceased: boolean;
    description: string;
    email: string;
    endLife: string;
    fatherName: string;
    fax: string;
    fieldOfWork: string;
    firstName: string;
    firstNameRepresentative: string;
    fullName: string;
    genderType: string;
    headquaters: string;
    id: string;
    idDocumentDate: string;
    idDocumentIssuedBy: string;
    idMarkupType: string;
    idNumber: string;
    idType: string;
    incapacitated: boolean;
    ladmId: string;
    lastName: string;
    lastNameRepresentative: string;
    logo: string;
    maritalStatusType: string;
    marriedName: string;
    middleName: string;
    minor: boolean;
    motherName: string;
    nationalId: string;
    objectOrigin: string;
    original: string;
    originalStatus: string;
    partyTitleType: string;
    personCount: number;
    phone1Extension: string;
    phone1Number: string;
    phone1Type: string;
    phone2Extension: string;
    phone2Number: string;
    phone2Type: string;
    placeOfEstablishment: string;
    prid: string;
    profession: string;
    protection: string;
    protectionLevel: string;
    protectionOwner: string;
    registrationNumber: string;
    representativeType: string;
    status: string;
    taxNumber: string;
    titleHolder: boolean;
    trCode: string;
    trId: string;
    trNo: string;
    tradeRegistrar: string;
    type: string;
    uid: string;
    version: number;
    versionRev: number;
}

